import { useState } from 'react'
import type { JSX } from 'react'
import type { RefObject } from 'react'
import './css/VideoThumbnailSlider.css'

// NOTE: for some reason, certain videos with will fail to publish if the last
// frame or close to the last frame are choosen. To avoid this, the code below
// sets the max allowable limit to 9980 (roughly 99.8% of the video's
// duration) which allows posts to publish.
export const RANGE_ALLOWABLE_MAX_LIMIT = 9980
export const RANGE_TOTAL_MAX = 10000

function VideoThumbnailSlider({
  videoRef,
}: {
  videoRef: RefObject<HTMLVideoElement>
}): JSX.Element | null {
  const [value, setValue] = useState(0)

  return (
    <div id="videoControls">
      <input
        onChange={(event): void => {
          if (!videoRef.current) {
            return
          }

          // moves the video & seek bar to correct place
          const time =
            videoRef.current.duration *
            (event.target.valueAsNumber / RANGE_TOTAL_MAX)

          // rounded to whole milliseconds: thumbnailOffset is a GraphQL Int,
          // and duration * fraction otherwise carries float noise through
          // to the saved offset.
          if (isFinite(time)) {
            videoRef.current.currentTime = Math.round(time * 1000) / 1000
          }

          setValue(event.target.valueAsNumber)
        }}
        value={value}
        type="range"
        min="0"
        max={RANGE_ALLOWABLE_MAX_LIMIT}
        aria-label="Thumbnail frame"
      />
    </div>
  )
}

export default VideoThumbnailSlider
